"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCUpIcon16Light = forwardRef_1.forwardRef('ArrowCUpIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M3.149 10.356a.5.5 0 0 1-.005-.707l3.793-3.843A1.5 1.5 0 0 1 9.065 5.8l3.789 3.789a.5.5 0 0 1-.708.707L8.358 6.506a.5.5 0 0 0-.71.003L3.857 10.35a.5.5 0 0 1-.707.005Z" })));
});
